<template>
  <div class="attachments-other-files d-flex flex-wrap required-block-cards">
    <b-card
      v-for="file in a.otherFiles"
      :key="file.id"
          class="media-card mb-2 shadow-sm"
          body-class="p-1 d-flex flex-column align-items-center"
          
        >
          <!-- Select for projectType 168 (projectCollectionFiles) -->
          <div
            v-if="a.isProject168"
            class="media-select-checkbox"
          >
            <b-form-checkbox
              :checked="a.isCollectionSelected(file)"
              @change="a.onCollectionCheckboxChange(file, $event)"
            />
          </div>

          <!-- File preview -->
          <div class="media-card-thumb mb-1">
            <img
              v-if="file.is_image"
              :src="file.url"
              alt="preview"
              class="media-thumb-img"
            >
            <div v-else-if="file.is_document && file.extension === 'pdf'">
              <b-icon
                icon="file-earmark-pdf"
                variant="danger"
                font-scale="3.2"
                class="my-3"
              />
            </div>
            <div v-else-if="file.is_video">
              <b-icon
                icon="camera-video"
                variant="primary"
                font-scale="3.2"
                class="my-3"
              />
            </div>
            <div v-else>
              <b-icon
                icon="file-earmark"
                variant="secondary"
                font-scale="3.2"
                class="my-3"
              />
            </div>
          </div>

          <div class="media-file-details w-100 text-center mb-1">
            <div
              class="file-title"
              style="word-break:break-all"
            >
              {{ file.file_name }}
            </div>
            <div class="file-meta text-muted small mt-1">
              {{ file.extension.toUpperCase() }} • {{ file.human_readable_size }}
            </div>
            <div
              v-if="file.groupKey"
              class="file-meta text-muted small mt-1"
            >
              {{ file.groupKey }}
            </div>
            <div class="file-meta text-muted small mt-1">{{ file.uploader ? file.uploader.name : '' }}
            </div>
            <div class="file-meta text-muted small mt-1">{{ file.created_at | formatJalali }}
            </div>
          </div>

          <!-- Notes Section -->
          <div class="media-card-notes w-100 ">
            <div
              v-if="!a.editingNotes[file.id]"
              class="notes-display"
            >
              <div
                v-if="file.notes"
                class="notes-content"
              >
                <p class="notes-text mb-0">
                  {{ file.notes }}
                </p>
              </div>
            </div>
            <div
              v-else
              class="notes-edit"
            >
              <b-form-textarea
                v-model="a.notesEdit[file.id]"
                placeholder="أدخل الملاحظات..."
                rows="3"
                class=""
                :disabled="a.savingNotes[file.id]"
              />
              <div class="d-flex gap-1">
                <b-button
                  size="sm"
                  variant="primary"
                  class="flex-fill"
                  :disabled="a.savingNotes[file.id]"
                  @click="a.saveNote(file)"
                >
                  <b-spinner
                    v-if="a.savingNotes[file.id]"
                    small
                    class="mr-1"
                  />
                  حفظ
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="flex-fill"
                  :disabled="a.savingNotes[file.id]"
                  @click="a.cancelEditingNote(file.id)"
                >
                  إلغاء
                </b-button>
              </div>
            </div>
          </div>

          <div class="media-card-actions d-flex flex-row justify-content-center gap-1 w-100">
            <b-button
              v-if="file.is_image || file.is_video || file.is_document"
              v-b-tooltip.hover.top="'معاينة'"
              :href="file.url"
              target="_blank"
              size="sm"
              variant="info"
            >
              <feather-icon icon="EyeIcon" size="12" />
            </b-button>
            <b-button
              v-b-tooltip.hover.top="'تحميل'"
              :href="file.download_url"
              target="_blank"
              size="sm"
              variant="success"
            >
              <feather-icon icon="DownloadIcon" size="12" />
            </b-button>
            <b-button
              v-if="a.hasPermission('delete media')"
              v-b-tooltip.hover.top="'حذف'"
              size="sm"
              variant="danger"
              @click="a.deleteFile(file.id)"
            >
              <feather-icon icon="Trash2Icon" size="12" />
            </b-button>
            <b-button
              v-if="!a.editingNotes[file.id] && a.hasPermission('edit projects')"
              v-b-tooltip.hover.top="file.notes ? 'تعديل الملاحظات' : 'إضافة ملاحظات'"
              size="sm"
              variant="outline-secondary"
              @click="a.startEditingNote(file)"
            >
              <feather-icon icon="EditIcon" size="12" />
            </b-button>
          </div>
    </b-card>
  </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsOtherFiles',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
